import React, { useCallback, useEffect, useState } from "react";
import { apiClient, useAuth } from "../App";
import { toast } from "sonner";
import { Card, CardContent } from "../components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Loader2 } from "lucide-react";
import { ActivityTab } from "../components/security/ActivityTab";
import { CodeScanTab } from "../components/security/CodeScanTab";

export const SuperuserOnly = () => (
  <Card data-testid="superuser-only-denied"><CardContent className="py-16 text-center text-sm text-slate-500">This page is only available to the platform superuser.</CardContent></Card>
);

export default function SecurityMonitorPage() {
  const { user } = useAuth();
  const isSuper = user?.role === "superuser";
  const [data, setData] = useState(null);

  const load = useCallback(() => apiClient.get("/security-monitor/summary").then((r) => setData(r.data))
    .catch((e) => toast.error(e.response?.data?.detail || "Could not load security data")), []);

  useEffect(() => { if (isSuper) load(); }, [isSuper, load]);

  const ack = async (id) => {
    try { await apiClient.post(`/security-monitor/alerts/${id}/acknowledge`); await load(); } catch { toast.error("Could not acknowledge alert"); }
  };

  if (!isSuper) return <SuperuserOnly />;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="security-monitor-page">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Security Monitor</h1>
        <p className="text-slate-500 mt-1">Sign-in activity across every organisation, spike alerts and third-party code scans</p>
      </div>
      <Tabs defaultValue="activity">
        <TabsList>
          <TabsTrigger value="activity" data-testid="security-tab-activity">Activity</TabsTrigger>
          <TabsTrigger value="scan" data-testid="security-tab-scan">Code Scan</TabsTrigger>
        </TabsList>
        <TabsContent value="activity" className="mt-4">
          {data ? <ActivityTab data={data} onAck={ack} /> : <div className="flex justify-center py-20"><Loader2 className="animate-spin text-slate-400" size={32} /></div>}
        </TabsContent>
        <TabsContent value="scan" className="mt-4"><CodeScanTab /></TabsContent>
      </Tabs>
    </div>
  );
}
